import React, { useState } from 'react'
import { colors, alpha } from '../style'

const AdministrativeFormInfo = ({ lang }) => {
  const [isTextExpanded, setIsTextExpanded] = useState(false)

  const content = {
    administrating: {
      pl: `<p><strong>Dobrowolność i prawo do wycofania zgody:</strong> <br/>Administratorami danych osobowych są podmioty wchodzące w skład OMIDA Group, zwane w dalszej części łącznie „Administratorami. Administratorzy wyznaczyli wspólny punkt kontaktowy, który obsługuje Inspektor ochrony danych OMIDA Group. W sprawach ochrony danych osobowych można się kontaktować z Administratorami:</p><ul><li>korespondencyjnie – kierując zapytania na adres Aleja Grunwaldzka 472C, 80-309 Gdańsk</li><li>drogą korespondencji elektronicznej na adres: iodo@omida.pl</li></ul><p>Wyrażenie zgody jest dobrowolne. W dowolnym momencie możesz wycofać swoją zgodę lub sprzeciwić się przetwarzaniu Twoich danych osobowych w celach dotyczących marketingu bezpośredniego. W zakresie w jakim zgoda została wycofana, nie będziemy mogli kontaktować się z Tobą aby przekazać Ci informacje lub wskazówki dotyczące produktów lub usług Omida Group. Wyrażenie lub niewyrażenie zgody nie ma wpływu na jakiekolwiek inne zgody wyrażone w przeszłości lub takie, które zostaną wyrażone w przyszłości. Każda zgoda pozostaje ważna do czasu wycofania.</p>`,
      en: `<p><strong>Voluntary consent and the right to withdraw consent:</strong> <br/>The personal data controllers are the entities belonging to the OMIDA Group, hereinafter collectively referred to as the “Controllers”. The Controllers have designated a common point of contact, which is operated by the OMIDA Group Data Protection Officer. The Controllers may be contacted in matters of personal data protection:</p><ul><li>by regular mail – mailing address: Aleja Grunwaldzka 472C, 80-309 Gdańsk</li><li>by electronic mail on: <a href="mailto:iodo@omida.pl">iodo@omida.pl</a></li></ul><p>The consent is given on a voluntary basis. You can withdraw your consent or object to the processing of your personal data for direct marketing purposes at any time. To the extent your consent has been withdrawn, we will not be able to contact you to provide you with information or directions regarding Omida Group products or services.</p><p>Giving your consent or the decision to not give it does not affect any other consents you have given in the past or that will be given in the future. Any and all consents remain valid until withdrawn.</p>`,
      zh: `<p><strong>自愿性质和撤回同意的权利：</strong> <br/>个人数据控制者是OMIDA集团内的实体，以下简称“控制者”。控制者已指定一个共同联系点，由OMIDA集团数据保护官管理。有关个人数据保护事宜，您可以联系控制者：</p><ul><li>通过邮件 – 发送询问至Aleja Grunwaldzka 472C, 80-309 Gdańsk</li><li>通过电子邮件 – 发送至： iodo@omida.pl</li></ul><p>同意是自愿的。您可以随时撤回同意或反对个人数据用于直接营销目的的处理。在同意被撤回的范围内，我们无法联系您以提供有关Omida集团产品或服务的任何信息或指导。给予或不给予同意不会影响过去或将来给予的任何其他同意。每个同意在撤回之前均有效。</p>`,

    },
    administratingSecond: {
      pl: `<p><sup>[1]</sup> Podmioty wchodzące w skład OMIDA Group:</p><ol><li>OMIDA Group S.A.</li><li>Omida VLS Sp. z o.o.</li><li>Omida Sea And Air S.A.</li><li>Omida Solutions Sp. z o.o.</li><li>Omida 7R Solutions Sp. z o.o.</li><li>Omida Iberica SL</li><li>Omida Finance Sp. z o.o.</li><li>Omida Shared Services Center Sp. z o.o.</li></ol>`,
      en: `<p><sup>[1]</sup> Entities belonging to the OMIDA Group:</p><ol><li>OMIDA Group S.A.</li><li>Omida VLS Sp. z o.o.</li><li>Omida Sea And Air S.A.</li><li>Omida Solutions Sp. z o.o.</li><li>Omida 7R Solutions Sp. z o.o.</li><li>Omida Iberica SL</li><li>Omida Finance Sp. z o.o.</li><li>Omida Shared Services Center Sp. z o.o.</li></ol>`,
      zh: `<p><sup>[1]</sup> OMIDA集团内的实体：</p><ol><li>OMIDA Group S.A.</li><li>Omida VLS Sp. z o.o.</li><li>Omida Sea And Air S.A.</li><li>Omida Solutions Sp. z o.o.</li><li>Omida 7R Solutions Sp. z o.o.</li><li>Omida Iberica SL</li><li>Omida Finance Sp. z o.o.</li><li>Omida Shared Services Center Sp. z o.o.</li></ol>`,
    },
    dictonary: {
      showMore: {
        pl: 'Pokaż więcej',
        en: 'Show more',
        zh: '显示更多',
      },
      showLess: {
        pl: 'Pokaż mniej', 
        en: 'Show less',
        zh: '显示更少',
      }
    }
  }

  return (
    <div css={sFormTextBottom}>
      <div css={[sAdminText, !isTextExpanded && sAdminTextCollapsed]}>
        <div dangerouslySetInnerHTML={{ __html: content.administrating[lang] }} />
        <div dangerouslySetInnerHTML={{ __html: content.administratingSecond[lang] }} css={{paddingTop: '10px'}}/>
      </div>
      <button 
        onClick={() => setIsTextExpanded(!isTextExpanded)}
        css={sShowMoreButton}
      >
        {isTextExpanded ? 
          content.dictonary.showLess?.[lang] || 'Show less' : 
          content.dictonary.showMore?.[lang] || 'Show more'
        }
      </button>
    </div>
  )
}

// Styles
const sFormTextBottom = {
  fontSize: '0.75rem',
  lineHeight: '1.5',
  color: colors.text.concat(alpha[60])
}

const sAdminText = {
  transition: 'max-height 0.3s ease-out',
  overflow: 'hidden',
  '& ul, & ol': {
    paddingLeft: '1.25rem',
    marginBottom: '.25rem'
  },
}

const sAdminTextCollapsed = {
  maxHeight: '20px',
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '25px',
  }
}

const sShowMoreButton = {
  background: 'none',
  border: 'none',
  color: colors.text,
  cursor: 'pointer',
  fontWeight: 700,
  padding: '0.5rem 0',
  fontSize: '10px',
  '&:hover': {
    textDecoration: 'underline',
  }
}

export default AdministrativeFormInfo
